// Bundle names of the "free daily gift" subscription packs. Rendered by
// FreePack in the promos / freeGifts sections and used by tab-interest to
// decide whether Promos has a claimable free pack. Kept dependency-free so
// the pure interest function can import it under `node --test`.
export const freeWebshopPacks = [
    'wssubdays7pack1',
    'wssubdays7pack5',
    'wssubdays14pack10',
    'stpatrickwebshop20',
    'stpatrickwebshop300',
    'newplayergiftsub1',
    'returnpack5',
];
